const initialUsersState = {
  ownersSearchString: '',
  owners: [],
  currentUser: undefined,
};

export default initialUsersState;
